import axios from "axios";

import APIRoutes from "../../APIRoutes";

import {
  SonicFacilityData,
  SonicFacility,
} from "../../../common/classes/SonicFacility";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * getRecommendFacilities
 *
 * Fetches recommend facilities data.
 *
 * @returns An array of facility and featured contents sentence.
 */

export const getRecommendFacilities = async (signal?: AbortSignal) => {
  try {
    const res = await axios.get(getAPIRoot(APIRoutes.get.featured_facility), {
      signal,
    });

    if (res.data.result == true) {
      const entries: Array<SonicFacilityData> = [];

      res.data.message.entries.forEach((e: any) => {
        const entry = SonicFacility.parseFromAPIResponse(e);
        entries.push(entry);
      });

      return { sentence: res.data.message.sentence, entries };
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};
